import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25308a8b")

_pushScopeId("data-v-25308a8b")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "swiper-container-com" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "swiper-button-prev" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "swiper-button-next" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.img, (item, i) => {
                return (_openBlock(), _createBlock(_Fragment, null, [
                  (item.u)
                    ? (_openBlock(), _createBlock("div", {
                        class: "swiper-slide",
                        key: i
                      }, [
                        _createVNode("img", {
                          src: item.u
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _hoisted_5,
            _hoisted_6
          ]),
          _createVNode("div", {
            class: "close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          })
        ]),
        _createVNode("div", {
          class: "bg",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]))
    : _createCommentVNode("", true)
})